import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M9.54993 17.6534L4.21533 12.3188L5.28456 11.2496L9.54993 15.515L18.7153 6.34961L19.7845 7.41881L9.54993 17.6534Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map